import { useNavigate } from "react-router-dom"; 
import { MapContainer, TileLayer, useMap, Marker, Popup, Tooltip } from 'react-leaflet'
import MapViewSideAlertBox from '../components/MapViewSideAlertBox';
import React, { useState, useEffect } from 'react'
import L from 'leaflet';

import LoadingOverlay from 'react-loading-overlay-ts';
import { loadSettings, getAlertLvl } from '../components/Functions'

import MuiDialogAlert from '../components/MuiDialogAlert';
import axios from 'axios';


const MapView = () => {

    let navigate = useNavigate();

    // 1
    const [devices, setDevices] = useState([])
    // 2

    // 3
    const [mapData, setMapData] = useState([])
    // 4
    const [alertsTotal, setAlertsTotal] = useState({})
    // 5
    const [settings, setSettings] = useState({
        "color_codes": {},
        "map": {},
        "alerts": {}
    })
    // 6
    const [loadingActive, setLoadingActive] = useState(false);
    // 7
    const [mapAttributes, setMapAttributes] = useState({
        "center" : [0,0],
        "zoom" : 0,
        "scroll": true
    });
    //8
    const [initLoad, setInitLoad] = useState(false)
    //9
    const [pageLoaded, setPageLoaded] = useState(false)

    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    let tmp_alert_status = {}

    useEffect(() => {

        const getSettings = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getSettings";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {// Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }

                console.log(loadSettings(response.data));

                // Set the retrieved data to the state
                setSettings(loadSettings(response.data));
                setInitLoad(true)
                console.log("Set Setting finished")


            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load settings data")
                setShowModal(true)   
            }
        };

        setLoadingActive(true);
        getSettings()
        setLoadingActive(false);

    }, [])

    useEffect(() => {

        const getDevices = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevicesData";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }
                console.log(response.data);
                // Set the retrieved data to the state
                setDevices(response.data)
                setPageLoaded(true)
            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load device data")
                setShowModal(true) 
            }
        };
        setLoadingActive(true);

        setMapAttributes({
            "center": [
                Number(settings.map.MAP_CENTER_LAT),
                Number(settings.map.MAP_CENTER_LONG)
            ],
            "zoom": settings.map.MAP_DEFAULT_ZOOM,
            "scroll": settings.map.MAP_SCROLL_WHEEL_ENABLE
        })

        if (initLoad) {    
            getDevices()
            setLoadingActive(false);
        }

    }, [settings])

    useEffect(() => {
        const initMapData = async () => {
            let tmp_array = []

            initAlertLvls(); // Set all alert count to 0


            for (let index = 0; index < devices.length; index++) {
                const device = devices[index];
                let tmp_json = {}

                let latestDeviceStatus = device.status

                if (latestDeviceStatus !== "") {
                    tmp_json.device_id = device.device_id
                    tmp_json.address = device.settings.address
                    tmp_json.description = device.settings.description

                    tmp_json.marker_pos = [device.settings.latitude, device.settings.longitude]
                    tmp_json.temperature = latestDeviceStatus.latest_transaction.TEMPERATURE.temperature ?? "No Reading"
                    tmp_json.batt_percent = latestDeviceStatus.latest_transaction.BATTERY.batt_percent ?? "No Reading"
                    tmp_json.vol_height = latestDeviceStatus.latest_transaction.VOLUME.vol_height ?? "No Reading"
                    tmp_json.vol_percent = latestDeviceStatus.latest_transaction.VOLUME.vol_percent ?? "No Reading"
                    tmp_json.vol_update_timestamp = latestDeviceStatus.latest_transaction.VOLUME.vol_update_timestamp ?? "No Reading"

                    tmp_json.alert_lvl = getAlertLvl(tmp_json.vol_percent,settings.alerts)
                    tmp_json.iconUrl = `${settings.alerts[tmp_json.alert_lvl.alert_type].icon_image_path}`

                    tmp_json.alert_type = tmp_json.alert_lvl.alert_type
                    tmp_alert_status[tmp_json.alert_type] += 1

                    tmp_array.push(tmp_json)

                    console.log(tmp_json)
                }

            }
            setAlertsTotal(tmp_alert_status)
            setMapData(tmp_array)
        };


        initMapData()
        console.log(mapData)
    }, [devices])


    function initAlertLvls() {
        let tmp_json = {}

        Object.keys(settings.alerts).forEach(key => {
            let alert = settings.alerts[key]
            tmp_json[alert.alert_type] = 0
        });
        tmp_alert_status = tmp_json
    }

    function SetMapAttr({attr}) {
        const map = useMap()
        map.setView(attr.center, attr.zoom);
        console.log('map center:', map.getCenter())
    }



    return (
        <main >
            <div align="left" style={{ height: "100%" }}>
                <LoadingOverlay
                    active={loadingActive}
                    spinner
                    text="Loading ..."
                    className="spinner_div"
                >
                {
                    pageLoaded && 
                <>
                    <div className='page_title'>Map View</div>
                    <table>
                        <tr>
                            <td>
                                <div>
                                    <MapContainer center={mapAttributes.center} zoom={settings.map.MAP_DEFAULT_ZOOM} scrollWheelZoom={settings.map.MAP_SCROLL_WHEEL_ENABLE}>
                                        <SetMapAttr attr={mapAttributes}/>
                                        <TileLayer
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />


                                        {
                                            mapData.map(data => {

                                                let iconUrl = data.iconUrl

                                                let customIcon = new L.Icon({
                                                    iconUrl: iconUrl,
                                                    iconSize: [25, 41],
                                                    iconAnchor: [12, 41],
                                                    popupAnchor: [1, -34],
                                                    shadowUrl: '/images/marker-shadow.png',
                                                    shadowSize: [41, 41],
                                                    shadowAnchor: [12, 41],
                                                });


                                                return (
                                                    <Marker position={data.marker_pos} icon={customIcon}>
                                                        <Popup>
                                                            <b>{data.description}</b><br /><br />
                                                            <b>Bin ID:</b> {data.device_id}<br />
                                                            <b>Address:</b> {data.address}<br />
                                                            <b>Temperature:</b> {data.temperature} °C<br />
                                                            <b>Volume:</b> {data.vol_percent} % ({data.vol_height}mm)<br />
                                                            <b>Volume Last Updated: </b> {data.vol_update_timestamp}<br />
                                                            <b>Batt Level:</b> {data.batt_percent}%<br />
                                                        </Popup>
                                                        <Tooltip direction="top" offset={[0, -50]} opacity={1} permanent>
                                                            {data.description}
                                                        </Tooltip>
                                                    </Marker>
                                                )
                                            })
                                        }

                                    </MapContainer>
                                </div>
                            </td>
                            <td valign="top">

                                <MapViewSideAlertBox
                                    alert_type="alert100"
                                    value={alertsTotal.alert100}
                                    description={settings.alerts.alert100.description}
                                    color_code={settings.alerts.alert100.color_code}
                                />
                                <MapViewSideAlertBox
                                    alert_type="alert75"
                                    value={alertsTotal.alert75}
                                    description={settings.alerts.alert75.description}
                                    color_code={settings.alerts.alert75.color_code}
                                    />
                                <MapViewSideAlertBox
                                    alert_type="alert_normal"
                                    value={alertsTotal.alert_normal}
                                    description={settings.alerts.alert_normal.description}
                                    color_code={settings.alerts.alert_normal.color_code}
                                    />
                                <MapViewSideAlertBox
                                    alert_type="alert_empty"
                                    value={alertsTotal.alert_empty}
                                    description={settings.alerts.alert_empty.description}
                                    color_code={settings.alerts.alert_empty.color_code}
                                />
                            </td>
                        </tr>
                    </table>
                
                </>


                }

                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        html={modalHtml}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />

                </LoadingOverlay>
            </div>
        </main>
    )
}

export default MapView